import { NavigateFunction, Location } from "react-router-dom";

export const history: { navigate: NavigateFunction | null; location: Location<any> | null } = {
  navigate: null,
  location: null,
};
